import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EmojiPicker, { QUICK_REACTIONS } from 'react/elements/EmojiPicker';
import LadderEmoji from 'react/elements/LadderEmoji';
import { messageSummary } from 'react/elements/contextMenu/messageSummary';
import { __ } from 'i18n/index';

import * as popupActions from '../redux/actions/popups';
import * as chatActions from '../redux/actions/chat';
import * as userActions from '../redux/actions/user';
import * as matchmakingActions from '../redux/actions/matchmaking';
import { ChatActions } from '../../components/ChatActions';
import { privateChatMessageHolder } from '../../components/PrivateChatMessageHolder';
import PopupTypes from '../../components/PopupTypes';
import { openPage } from 'navigation/pageLocation';

class ContextMenuContainer extends Component {
	static defaultProps = {
		showFriendOptionsOnly: false,
	};

	constructor(props) {
		super(props);
		this.state = { showReactionPicker: false, showModerationTools: false };
		this.toggleReactionPicker = this.toggleReactionPicker.bind(this);
		this.onReactionEmojiSelected = this.onReactionEmojiSelected.bind(this);
		this.toggleModerationTools = this.toggleModerationTools.bind(this);
		this.copyChatMessageTextToClipboard = this.copyChatMessageTextToClipboard.bind(this);
		this.copyUsernameToClipboard = this.copyUsernameToClipboard.bind(this);
		this.openPrivateChatWithUser = this.openPrivateChatWithUser.bind(this);
		this.editChatMessageClick = this.editChatMessageClick.bind(this);

		this.deleteChatMessage = this.deleteChatMessage.bind(this);
		this.removeChatMessage = this.removeChatMessage.bind(this);

		this.massDeleteChatMessagesByPlayer = this.massDeleteChatMessagesByPlayer.bind(this);
		this.massRemoveChatMessagesByPlayer = this.massRemoveChatMessagesByPlayer.bind(this);
		this.undeleteChatMessage = this.undeleteChatMessage.bind(this);

		this.chatMessageMassDeleteMouseEnter = this.chatMessageMassDeleteMouseEnter.bind(this);
		this.chatMessageMassDeleteMouseLeave = this.chatMessageMassDeleteMouseLeave.bind(this);
		this.initiateReport = this.initiateReport.bind(this);

		this.viewPlayerInfractions = this.viewPlayerInfractions.bind(this);
		this.viewPlayerProfile = this.viewPlayerProfile.bind(this);

		this.addMention = this.addMention.bind(this);
		this.sendMessage = this.sendMessage.bind(this);

		this.acceptFriendRequest = this.acceptFriendRequest.bind(this);
		this.declineFriendRequest = this.declineFriendRequest.bind(this);
		this.cancelSentFriendRequest = this.cancelSentFriendRequest.bind(this);
		this.endFriendship = this.endFriendship.bind(this);
		this.unignorePlayer = this.unignorePlayer.bind(this);
		this.showProfileCard = this.showProfileCard.bind(this);

		this.viewLadderActivity = this.viewLadderActivity.bind(this);
	}

	viewLadderActivity() {
		const { viewGameActivity, preferredGameFilter } = this.props;
		if(!preferredGameFilter) {
			console.error('Somebody cheated to get here');
			return;
		}
		viewGameActivity(preferredGameFilter);
		this.close();
	}

	unignorePlayer() {
		const { unignorePlayer, player } = this.props;
		unignorePlayer(player);
		this.close();
	}

	acceptFriendRequest() {
		const { acceptFriendRequest, player } = this.props;
		acceptFriendRequest(player);
		this.close();
	}

	declineFriendRequest() {
		const { declineFriendship, player } = this.props;
		declineFriendship(player);
		this.close();
	}

	cancelSentFriendRequest() {
		const { cancelFriendship, player } = this.props;
		cancelFriendship(player);
		this.close();
	}

	endFriendship() {
		const { endFriendship, player } = this.props;
		endFriendship(player);
		this.close();
	}

	addMention() {
		const { chatMessage, player } = this.props;
		chatMessage.chatMessages.addMention(player);
		this.close();
	}

	toggleReactionPicker() {
		this.setState((previousState) => ({ showReactionPicker: !previousState.showReactionPicker }), () => {
			this.props.popupResizeProbablyHappened?.();
		});
	}

	onReactionEmojiSelected(emoji) {
		const { chatMessage } = this.props;
		if(chatMessage) {
			chatMessage.toggleReaction(emoji.skin > 1 ? emoji.colons : emoji.id);
		}
		this.close();
	}

	quickReact(emoji) {
		this.props.chatMessage.toggleReaction(emoji);
		this.close();
	}

	toggleModerationTools() {
		this.setState((previousState) => ({ showModerationTools: !previousState.showModerationTools }), () => {
			this.props.popupResizeProbablyHappened?.();
		});
	}

	sendMessage() {
		const { player } = this.props;
		privateChatMessageHolder.openPrivateChat(player);
		this.close();
	}

	viewPlayerInfractions() {
		const { player } = this.props;
		openPage(player.getInfractionsUrl());
	}

	showProfileCard() {
		const { userClickPopupOpen, player, startPosition } = this.props;
		userClickPopupOpen(player, PopupTypes.PROFILE_CARD, startPosition);
	}

	viewPlayerProfile() {
		const { player } = this.props;
		openPage(player.getProfileUrl());
	}

	initiateReport() {
		const { chatMessage } = this.props;
		ChatActions.reportToMods(`Reporting ${chatMessage.player.username}`, null, chatMessage.getContext());
		this.close();
	}

	chatMessageMassDeleteMouseEnter() {
		const { chatMessage, chatMessageDeleteHighlightBegin } = this.props;
		chatMessageDeleteHighlightBegin(chatMessage.chatMessages, chatMessage.player);
	}

	chatMessageMassDeleteMouseLeave() {
		const { chatMessage, chatMessageDeleteHighlightEnd } = this.props;
		chatMessageDeleteHighlightEnd(chatMessage.chatMessages, chatMessage.player);
	}


	undeleteChatMessage() {
		const { chatMessage } = this.props;
		if(chatMessage.is_shadow_muted) {
			chatMessage.revealMessage();
		}
		else {
			chatMessage.undeleteMessage();
		}
		this.close();
	}

	massDeleteChatMessagesByPlayer() {
		const { chatMessage } = this.props;
		if(!confirm('Delete all visible messages posted by ' + chatMessage.player.username + '?')) {
			return;
		}
		chatMessage.chatMessages.deleteAllByPlayer(chatMessage.player);
		this.close();
	}

	massRemoveChatMessagesByPlayer() {
		const { chatMessage } = this.props;
		if(!confirm('REMOVE all visible messages posted by ' + chatMessage.player.username + '?')) {
			return;
		}
		chatMessage.chatMessages.removeAllByPlayer(chatMessage.player);
		this.close();
	}

	deleteChatMessage() {
		const { chatMessage } = this.props;
		chatMessage.deleteMessage();
		this.close();
	}

	removeChatMessage() {
		const { chatMessage } = this.props;
		chatMessage.removeMessage();
		this.close();
	}

	editChatMessageClick() {
		const { chatMessage, setChatMessageToEditMode } = this.props;
		if(chatMessage.id) {
			setChatMessageToEditMode(chatMessage);
			this.close();
		}
	}

	openPrivateChatWithUser() {
		const { player } = this.props;
		privateChatMessageHolder.openPrivateChat(player);
		this.close();
	}

	copyChatMessageTextToClipboard() {
		const { chatMessage } = this.props;
		if(!chatMessage || chatMessage.deleted) {
			this.close();
			return;
		}

		copyToClipboard(chatMessage.message);
		this.close();
	}

	copyUsernameToClipboard() {
		const { player } = this.props;
		if(!player) {
			this.close();
			return;
		}
		copyToClipboard(player.username);
		this.close();
	}

	close() {
		const { closePopup } = this.props;
		if(closePopup) {
			closePopup();
		}
	}

	friendActions() {
		const { player } = this.props;
		const friend = player.friend || {};
		const actions = [];
		if(myUser.ignore_list[player.id]) {
			actions.push({ label: __('Unignore'), onClick: this.unignorePlayer });
		}
		if(friend.waiting_response) {
			actions.push({ label: __('Accept Friend Request'), onClick: this.acceptFriendRequest });
			actions.push({ label: __('Decline Friend Request'), onClick: this.declineFriendRequest });
		}
		if(friend.request_sent) {
			actions.push({ label: __('Cancel Sent Friend Request'), onClick: this.cancelSentFriendRequest });
		}
		if(friend.is_friend) {
			actions.push({ label: __('End Friendship!?'), onClick: this.endFriendship });
		}
		return actions;
	}

	render() {
		const { chatMessage } = this.props;
		if(chatMessage?.id && this.state.showReactionPicker) {
			return <div className='specific_menu active context_menu created context_menu--emoji'>
				<EmojiPicker reaction onSelect={this.onReactionEmojiSelected} onClose={this.toggleReactionPicker} />
			</div>;
		}
		if(chatMessage) {
			return this.renderMessageMenu();
		}
		return this.renderPlayerMenu();
	}

	renderMessageMenu() {
		const { chatMessage, player, selectedMainChat } = this.props;
		const { showModerationTools } = this.state;
		const isMine = !!chatMessage.isMyMessage();
		const canEdit = chatMessage.canBeEdited ? chatMessage.canBeEdited() : isMine;
		const isMod = !!chatMessage.isModOfMessage;
		const showPlayerActions = !!player && !isMine;
		return (
			<div className='specific_menu active context_menu created context_menu--message'>
				{!!chatMessage.id &&
				<div className='message_menu__reactions' role='group' aria-label={__('Quick reactions')}>
					{QUICK_REACTIONS.map((emoji) => (
						<button
							type='button'
							key={emoji}
							className='message_menu__reaction'
							aria-label={__('React with %s', `:${emoji}:`)}
							title={`:${emoji}:`}
							aria-pressed={!!chatMessage.hasMyReaction(emoji)}
							onClick={() => this.quickReact(emoji)}
						>
							<LadderEmoji emoji={emoji} size={22} tooltip={false} />
						</button>
					))}
					<button
						type='button'
						className='message_menu__reaction message_menu__reaction--more'
						aria-label={__('More reactions')}
						title={__('More reactions')}
						onClick={this.toggleReactionPicker}
					>
						<i className='fa fa-smile-o' aria-hidden='true' /><i className='fa fa-plus' aria-hidden='true' />
					</button>
				</div>
				}
				<div className='message_menu__summary' data-testid='message-menu-summary'>
					{!!player && <span className='message_menu__summary-name'>{player.username}</span>}
					<span className='message_menu__summary-text'>{messageSummary(chatMessage)}</span>
				</div>
				<div className='message_menu__rows'>
					{selectedMainChat && showPlayerActions &&
					<MessageMenuRow icon='at' onClick={this.addMention}>{__('Mention')}</MessageMenuRow>
					}
					{canEdit &&
					<MessageMenuRow icon='pencil' onClick={this.editChatMessageClick}>{__('Edit')}</MessageMenuRow>
					}
					{!chatMessage.kind &&
					<MessageMenuRow icon='copy' onClick={this.copyChatMessageTextToClipboard}>{__('Copy text')}</MessageMenuRow>
					}
					{isMine && !chatMessage.deleted &&
					<MessageMenuRow icon='trash' danger onClick={this.deleteChatMessage}>{__('Delete')}</MessageMenuRow>
					}
				</div>
				{showPlayerActions &&
				<React.Fragment>
					<div className='message_menu__player'>
						<button type='button' onClick={this.viewPlayerProfile}><i className='fa fa-user' aria-hidden='true' />{__('Profile')}</button>
						<button type='button' onClick={this.openPrivateChatWithUser}><i className='fa fa-comment' aria-hidden='true' />{__('Message')}</button>
						<button type='button' onClick={this.copyUsernameToClipboard}><i className='fa fa-clipboard' aria-hidden='true' />{__('Copy name')}</button>
					</div>
					<div className='message_menu__rows'>
						{this.friendActions().map(({ label, onClick }) => (
							<MessageMenuRow key={label} icon='user-plus' onClick={onClick}>{label}</MessageMenuRow>
						))}
						<MessageMenuRow icon='flag' danger onClick={this.initiateReport} title={__('Report for inappropriate or malicious behavior')}>
							{__('Report')}
						</MessageMenuRow>
					</div>
				</React.Fragment>
				}
				{isMod &&
				<div className='message_menu__rows message_menu__moderation'>
					<button
						type='button'
						className='message_menu__row message_menu__moderate'
						aria-expanded={showModerationTools}
						onClick={this.toggleModerationTools}
					>
						<i className='fa fa-shield' aria-hidden='true' />
						<span>{__('Moderate')}</span>
						<i className='fa fa-chevron-right message_menu__chevron' aria-hidden='true' />
					</button>
					{showModerationTools &&
					<div className='message_menu__moderation-tools'>
						{!chatMessage.is_shadow_muted &&
						<MessageMenuRow icon='eye-slash' danger onClick={this.removeChatMessage} hint={__('Gone for everyone')}>
							{__('Remove')}
						</MessageMenuRow>
						}
						{!chatMessage.deleted && !isMine &&
						<MessageMenuRow icon='trash' danger onClick={this.deleteChatMessage} hint={__('Shows as deleted, can be undone')}>
							{__('Delete')}
						</MessageMenuRow>
						}
						{chatMessage.isRemovedInSomeWay() &&
						<MessageMenuRow icon='undo' onClick={this.undeleteChatMessage} hint={__('Brings back a deleted or flagged message')}>
							{__('Undelete')}
						</MessageMenuRow>
						}
						{!!player && !isMine &&
						<React.Fragment>
							<MessageMenuRow
								icon='clone'
								danger
								onClick={this.massRemoveChatMessagesByPlayer}
								onMouseEnter={this.chatMessageMassDeleteMouseEnter}
								onMouseLeave={this.chatMessageMassDeleteMouseLeave}
							>
								{__('Remove all by %s', player.username)}
							</MessageMenuRow>
							<MessageMenuRow
								icon='clone'
								danger
								onClick={this.massDeleteChatMessagesByPlayer}
								onMouseEnter={this.chatMessageMassDeleteMouseEnter}
								onMouseLeave={this.chatMessageMassDeleteMouseLeave}
							>
								{__('Delete all by %s', player.username)}
							</MessageMenuRow>
						</React.Fragment>
						}
					</div>
					}
				</div>
				}
			</div>
		);
	}

	renderPlayerMenu() {
		const { player, preferredGameFilter, showFriendOptionsOnly } = this.props;
		const ladder = preferredGameFilter ? preferredGameFilter.gameRoom : null;
		return (
			<div className='specific_menu active context_menu created'>
				{!!preferredGameFilter &&
				<div className='specific_menu active game_filters'>
					<ContextMenuGroup>
						<ContextMenuItem>Toggle Search Visibility{' '}
							{!!preferredGameFilter.filtered_on ? <span className='off'>Off</span> :
								<span className='on'>On</span>}
						</ContextMenuItem>
						<ContextMenuItem>
							Only show <span className='game_name'>{ladder.name}</span> Searches!
						</ContextMenuItem>
						<ContextMenuItem>
							Enable <span className='on'>All</span> Games!
						</ContextMenuItem>
					</ContextMenuGroup>
					<ContextMenuGroup>
						<ContextMenuItem
							onClick={this.viewLadderActivity}
						>
							View <span className='game_name'>{ladder.name}</span>'s Activity
						</ContextMenuItem>
					</ContextMenuGroup>
				</div>
				}
				{!!player &&
				<React.Fragment>
					<div className='specific_menu username_click active username_click'>
						{showFriendOptionsOnly &&
						<ContextMenuItem
							onClick={this.showProfileCard}
						>
							Profile Card
						</ContextMenuItem>
						}
						{!showFriendOptionsOnly &&
						<ContextMenuItem
							onClick={this.viewPlayerProfile}
							className='profile_page_option basically_a_url'>
							Profile Page
						</ContextMenuItem>
						}
						<ContextMenuItem onClick={this.openPrivateChatWithUser} className='send_message'>
							Direct Message
						</ContextMenuItem>
						{!showFriendOptionsOnly &&
						<ContextMenuItem onClick={this.copyUsernameToClipboard}>
							Copy Username
						</ContextMenuItem>
						}
					</div>
					{this.friendActions().length > 0 &&
					<div className='specific_menu active chat_message_popup'>
						<ContextMenuGroup>
							{this.friendActions().map(({ label, onClick }) => (
								<ContextMenuItem key={label} onClick={onClick}>{label}</ContextMenuItem>
							))}
						</ContextMenuGroup>
					</div>
					}
				</React.Fragment>
				}
			</div>
		);
	}
}

function MessageMenuRow({ icon, danger = false, hint, children, ...props }) {
	return (
		<button type='button' className={`message_menu__row${danger ? ' message_menu__row--danger' : ''}`} {...props}>
			<i className={`fa fa-${icon}`} aria-hidden='true' />
			<span>
				{children}
				{hint && <React.Fragment>{' '}<span className='message_menu__hint'>{hint}</span></React.Fragment>}
			</span>
		</button>
	);
}

class ContextMenuGroup extends Component {
	render() {
		const { children, ...props } = this.props;
		return (
			<div {...props} className='menu_group active'>
				{children}
			</div>
		);
	}
}

class ContextMenuItem extends Component {
	render() {
		const { children, onClick, className, ...props } = this.props;
		return (
			<div onClick={onClick} {...props}
			     className={`menuitem ${className} ${onClick ? '' : 'disabled'}`}>{children}</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		...state.popups,
		...state.chat,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		...popupActions,
		...chatActions,
		...userActions,
		...matchmakingActions,
	}, dispatch);
}


export { ContextMenuContainer };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ContextMenuContainer);